import { FilterConfig } from '../../../../model/filter';
import { IP } from '../../../../dtos/version.dto';
import { ActionType, DirectionFilterNames, IPDirection } from '../../../../utils/enums';

export const ipListFiltersConfig: FilterConfig<IP> = {
    searchBox: { placeholder: 'Search IP', byFields: ['value', 'description']},
    dropdownList: [
        {
            name: 'Action',
            options: [
                { label: 'All', filterFn: () => true },
                { label: ActionType.ALLOW, filterFn: (ip: IP) => ip.actionType === ActionType.ALLOW },
                { label: ActionType.BLOCK, filterFn: (ip: IP) => ip.actionType === ActionType.BLOCK },
            ]
        },
        {
            name: 'Direction',
            options: [
                { label: DirectionFilterNames.ALL, filterFn: () => true },
                { label: DirectionFilterNames.OUTBOUND, filterFn: (ip: IP) => ip.direction === IPDirection.OUTBOUND },
                { label: DirectionFilterNames.INTBOUND, filterFn: (ip: IP) => ip.direction === IPDirection.INTBOUND },
                { label: DirectionFilterNames.BOTH,     filterFn: (ip: IP) => ip.direction === IPDirection.BOTH },
            ]
        },
        {
            name: 'IP Type',
            options: [
                { label: 'All', filterFn: () => true },
                { label: 'IPv4', filterFn: (ip: IP) => ip.ipVersion === 4 },
                { label: 'IPv6', filterFn: (ip: IP) => ip.ipVersion === 6 }
            ]
        }
    ]
};
